<template>
<div>
    <!-- CSS Global Compulsory -->
    <link rel="stylesheet" href="../../static/assets/bootstrap/css/bootstrap.min.css">
    <link rel="stylesheet" href="../../static/assets/css/style.css">

    <!-- CSS Header and Footer -->
    <link rel="stylesheet" href="../../static/assets/css/header.css">
    <link rel="stylesheet" href="../../static/assets/css/footer.css">
    <div>
      <router-link to="/"><img style="position: absolute;z-index:2;left: 4%;top: 2%;height: 55px;" src="../../static/assets/img/headerlogo.png"/></router-link>
        <img src="../../static/assets/img/txinfoheader.png" alt="" width="100%">
              <img style="position: absolute;z-index:2;left: 30%;top: 30%;height: 130px;"  src="../../static/assets/img/txinfo/infoheadertext.png"/>

    </div>
    <div class="container content">
        <div class="col-md-20">
            <div class="row margin-bottom-150">
                <div class="col-md-3">
                    <h1 style="font-weight: 500;color: black;">社交</h1>
                    <h3 style="margin-top: 40px;font-weight: 500;color: black;">通过知识分享和技能交易建立自身社交塔圈</h3>
                    <h4 style="margin-top: 20px;font-weight: 400;">塔兮拥有自己的账号体系，在使用塔兮时用户之间可以互相关注、收藏、评论、加好友私聊等。如果是明星达人还可以建立自己的塔圈群，对自己的粉丝进行管理维护。当然，普通用户也可以申请加入自己喜欢的明星达人群进行交流学习。塔兮还可以根据用户所在地址，推荐附近的明星达人所简历的各类塔圈群，让用户快速找到自己需要或者适合自己的塔圈。总之在塔兮我们可以做到以“技”会友，打造出自己独有的高质量社交圈。</h4>
                </div>
                <div class="col-md-3">
                    <img class="img-responsive margin-bottom-20" src="../../static/assets/img/txinfo/dt1.png" alt="">
                </div>
                <div class="col-md-3">
                    <img class="img-responsive margin-bottom-20" src="../../static/assets/img/txinfo/dt2.png" alt="">
                </div>
                <div class="col-md-3">
                    <img class="img-responsive margin-bottom-20" src="../../static/assets/img/txinfo/dt3.png" alt="">
                </div>
            </div>
            <div class="row margin-bottom-150">
                <div class="col-md-3">
                    <h1 style="font-weight: 500;color: black;">学习</h1>
                    <h3 style="margin-top: 40px;font-weight: 500;color: black;">优秀达人视频课程教学，简单、方便随看随学</h3>
                    <h4 style="margin-top: 20px;font-weight: 400;">塔兮“小课”涵盖教育、美食、音乐、舞蹈、游戏、运动、穿搭等等视频课程，可随时随地在线观看学习，高清流畅，全程无广告，让用户拥有完美观看体验！小课采用合集模式，短视频方式观看，方便用户分类收藏，自由选择学习进度，拥有社交账号体系，可与课程发布者随时沟通交流，提高学习效率！塔兮小课时长均不超过15分钟，均采用通俗易懂的方式将学习模式轻松化，娱乐化，让生活中的碎片化时间可以得到充分利用。</h4>
                </div>
                <div class="col-md-3">
                    <img class="img-responsive margin-bottom-20" src="../../static/assets/img/txinfo/xx1.png" alt="">
                </div>
                <div class="col-md-3">
                    <img class="img-responsive margin-bottom-20" src="../../static/assets/img/txinfo/xx2.png" alt="">
                </div>
                <div class="col-md-3">
                    <img class="img-responsive margin-bottom-20" src="../../static/assets/img/txinfo/xx3.png" alt="">
                </div>
            </div>
            <div class="row margin-bottom-150">
                <div class="col-md-3">
                    <h1 style="font-weight: 500;color: black;">点滴</h1>
                    <h3 style="margin-top: 40px;font-weight: 500;color: black;">记录个人生活成长的时间轴，私人定制塔兮回忆录</h3>
                    <h4 style="margin-top: 20px;font-weight: 400;">塔兮的点滴生活部分不仅涵盖了用户自己发布的所有内容记录，还可以发布自己想要写的文字或者语音记录，按照发布时间，形成记录个人生活成长的时间轴。<br>塔兮的点滴记录功能在以后还将接入各个第三方平台数据，例如各大视频网站、音乐软件、阅读软件等生活信息平台，让自己的生活成长记录更加娱乐化，全面化。<br>点滴记录还将开通信息导出功能，将自己的成长轨迹做成电子相册或者视频回忆！</h4>
                </div>
                <div class="col-md-3">
                    <img class="img-responsive margin-bottom-20" src="../../static/assets/img/txinfo/dd1.png" alt="">
                </div>
                <div class="col-md-3">
                    <img class="img-responsive margin-bottom-20" src="../../static/assets/img/txinfo/dd2.png" alt="">
                </div>
                <div class="col-md-3">
                    <img class="img-responsive margin-bottom-20" src="../../static/assets/img/txinfo/dd3.png" alt="">
                </div>
            </div>
            <div class="row margin-bottom-150">
                <div class="col-md-3">
                    <h1 style="font-weight: 500;color: black;">随意秀</h1>
                    <h3 style="margin-top: 40px;font-weight: 500;color: black;">日常所见所闻的生活娱乐秀</h3>
                    <h4 style="margin-top: 20px;font-weight: 400;">随意秀是用户发布日常所见所闻的生活娱乐秀；塔兮提倡秀出自己的生活，秀出自己的技能，并成为塔兮明星达人。<br>目前塔兮已经拥有百万高清人图、景图等各种清晰大图无水印。无论是娱乐明星、美女网红、靓女车模、时尚帅哥、肌肉猛男，还是风景名胜、世界名桥名校、民间小吃等等应有尽有。<br>塔兮随意秀界面设计，清新简洁，点滑之间尽享畅爽体验，不光可以浏览海量高清大图，还可同时在线点赞评论收藏，简单省流量，互动性强。不同分类，不同推荐，你要的都在这里。</h4>
                </div>
                <div class="col-md-3">
                    <img class="img-responsive margin-bottom-20" src="../../static/assets/img/txinfo/syx1.png" alt="">
                </div>
                <div class="col-md-3">
                    <img class="img-responsive margin-bottom-20" src="../../static/assets/img/txinfo/syx2.png" alt="">
                </div>
                <div class="col-md-3">
                    <img class="img-responsive margin-bottom-20" src="../../static/assets/img/txinfo/syx3.png" alt="">
                </div>
            </div>
            <div class="row margin-bottom-150">
                <div class="col-md-3">
                    <h1 style="font-weight: 500;color: black;">技能变现</h1>
                    <h3 style="margin-top: 40px;font-weight: 500;color: black;">塔兮分为“小课”线上变现和“我能”线下交易变现</h3>
                    <h4 style="margin-top: 20px;font-weight: 400;">1、小课<br>技能拥有者可以不同话题的视频课程合集，并制定合理的线上售卖价格，以塔兮平台的虚拟货币（塔币）为交易货币，直接在塔兮创业赚钱，完成线上技能变现交易。<br>2、我能<br>塔兮平台可以通过“我能”功能，发布自己的技能秀，并标注自身可以提供的线下服务，完成自身技能的线下变现。塔兮会基于地理位置等信息在线智能筛选最佳技能需求服务订单供技能拥有者洽谈交易并完成变现。</h4>
                </div>
                <div class="col-md-3">
                    <img class="img-responsive margin-bottom-20" src="../../static/assets/img/txinfo/jnbx1.png" alt="">
                </div>
                <div class="col-md-3">
                    <img class="img-responsive margin-bottom-20" src="../../static/assets/img/txinfo/jnbx2.png" alt="">
                </div>
                <div class="col-md-3">
                    <img class="img-responsive margin-bottom-20" src="../../static/assets/img/txinfo/jnbx3.png" alt="">
                </div>
            </div>
            <div class="row margin-bottom-150">
                <div class="col-md-3">
                    <h1 style="font-weight: 500;color: black;">求助</h1>
                    <h3 style="margin-top: 40px;font-weight: 500;color: black;">遇事一键求助，召集牛人来帮忙</h3>
                    <h4 style="margin-top: 20px;font-weight: 400;">在塔兮上我们可以找到家政、搬家、保洁、维修、装潢、培训、月嫂、家教、健身、咨询等各种技能服务的达人。<br>塔兮拥有“我要”功能：用户只需要按照自身需要的服务种类发布一个图片和视频介绍，进行求助即可。塔兮会基于地理位置等信息在线智能筛选最佳技能提供者供需求者联系。<br>在塔兮的服务生态圈内，已实现生活服务品类全覆盖，平台拥有100%技能服务者的真是认证，服务质量有保证。做到“服务全”，“上门快”，“有保障”。</h4>
                </div>
                <div class="col-md-3">
                    <img class="img-responsive margin-bottom-20" src="../../static/assets/img/txinfo/qz1.png" alt="">
                </div>
                <div class="col-md-3">
                    <img class="img-responsive margin-bottom-20" src="../../static/assets/img/txinfo/qz2.png" alt="">
                </div>
                <div class="col-md-3">
                    <img class="img-responsive margin-bottom-20" src="../../static/assets/img/txinfo/qz3.png" alt="">
                </div>
            </div>

        </div>
    </div>


    <div class="footer-v1">
        <div class="footer">
            <div class="container">
                <div class="row">
                    <!-- About -->
                    <div class="col-md-2">
                      <img class="img-responsive " src="../../static/assets/img/txzmtm.png" alt="">
                    </div><!--/col-md-3-->
                    <!-- End About -->
                    <!-- Latest -->
                    <div class="col-md-4 md-margin-bottom-40">
                        <div class="posts">
                            <div class="headline"><h2>备案信息</h2></div>
                            <ul class="list-unstyled latest-list">
                                <li>
                                  <a href="../../static/privacy.html" style="color: rgb(38, 104, 233);">隐私协议</a>
                                </li>
                                <li>
                                  <a href="../../static/protocol.html" style="color: rgb(38, 104, 233);">用户服务协议</a>
                                </li>
                                <li>
                                  <a href="../../static/tort.html" style="color: rgb(38, 104, 233);">侵权投诉指引</a>
                                </li>
                                <li style="color:white">
                                  <a href="https://beian.miit.gov.cn/" target="_blank">鄂ICP备 18014986号-1</a><br>2019 &copy; 武汉云上塔兮信息技术有限公司 版权所有

                                </li>
                            </ul>
                        </div>
                    </div><!--/col-md-3-->
                    <!-- End Latest -->

                    <!-- Address -->
                    <div class="col-md-4 map-img ">
                        <div class="headline"><h2>联系我们</h2></div>
                        <address class="md-margin-bottom-40">
                            地址：湖北省武汉市洪山区珞喻路618号东方怡景大厦B座<br>
                            电话：027-88515977<br>
                            Email: <a href="mailto:towerx@towerxi.cn" style="color:rgb(38, 104, 233); ">towerx@towerxi.cn</a>
                        </address>
                    </div><!--/col-md-3-->
                    <!-- End Address -->
                </div>
            </div>
        </div><!--/footer-->


    </div>

</div>
</template>

<script>
export default {
    name:'TXInfo'
}
</script>



// WEBPACK FOOTER //
// src/views/TXInfo.vue